import React from 'react';
import BaseTile from '../../../components/Tile/BaseTile';
import { useMissingObjectTypeKpi } from './hooks/useMissingObjectTypeKpi';
import { formatGermanNumber, formatGermanPercentage } from '../../../utils/numberFormat';

const Stat = ({ label, value }) => (
  <div className="flex flex-col items-center">
    <div className="text-xs text-gray-500">{label}</div>
    <div className="text-lg font-semibold">
      {typeof value === 'number' ? formatGermanNumber(value, { decimals: 0 }) : value}
    </div>
  </div>
);

const MissingObjectTypes = ({ activeFile, batchData }) => {
  const { data, loading, error } = useMissingObjectTypeKpi(activeFile, { batchData });

  const total = data?.total_objects ?? 0;
  const missing = data?.objects_missing_type ?? 0;
  const ratePct = total > 0 ? (data.missing_ratio || 0) : 0;

  return (
    <BaseTile title="Objects Missing Type" loading={loading} error={error} minHeight="sm" padding="default">
      <div className="h-full flex flex-col items-center justify-center gap-4">
        <div className="text-4xl font-extrabold text-orange-600">{formatGermanNumber(missing, { decimals: 0 })}</div>
        <div className="text-sm text-gray-600">objects with missing/invalid type</div>
        <div className="flex gap-6">
          <Stat label="Total Objects" value={total} />
          <Stat label="Missing %" value={formatGermanPercentage(ratePct, 2)} />
        </div>
      </div>
    </BaseTile>
  );
};

export default MissingObjectTypes;
